import React from "react";
import { useLanguage } from "../../../../../context/LanguageContext";
import { useAdminProductsTranslation } from "../../translations";

// Note: Product limits are enforced server-side in Cloud Functions
// The createProduct function will return 'resource-exhausted' error if limit reached
const ProductsActionBar = ({
    onAddProduct,
    onViewSales,
    activeSalesCount,
    onBulkAction,
    selectedCount,
    search,
    setSearch,
    categoryFilter,
    setCategoryFilter,
    statusFilter,
    setStatusFilter,
    allCategories
}) => {
    const { language } = useLanguage();
    const { t } = useAdminProductsTranslation(language);

    return (
        <div className="products-actions-bar">
            <div className="products-actions-left">
                <button
                    className="admin-primary-btn"
                    onClick={onAddProduct}
                >
                    {t('addNewProduct')}
                </button>


                <div className="bulk-actions">
                    <select
                        className="bulk-select"
                        onChange={(e) => onBulkAction(e.target.value)}
                        value=""
                    >
                        <option value="" disabled>{t('bulkActions')}</option>
                        <option value="delete">{t('delete')}</option>
                        <option value="active">{t('setAsActive')}</option>
                        <option value="inactive">{t('setAsInactive')}</option>

                    </select>

                    <span className="selected-count">
                        {selectedCount > 0 && `${selectedCount} ${t('selected')}`}
                    </span>
                </div>
            </div>

            <div className="products-actions-right">
                <div className="product-search">
                    <input
                        type="text"
                        placeholder={t('searchProducts')}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                <select
                    className="product-filter"
                    value={categoryFilter}
                    onChange={(e) => setCategoryFilter(e.target.value)}
                >
                    {allCategories.map((category, index) => (
                        <option key={index} value={category}>
                            {category === "All" ? t('allCategories') : category}
                        </option>
                    ))}
                </select>

                <select
                    className="product-filter"
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                >
                    <option value="All">{t('allStatus')}</option>
                    <option value="active">{t('active')}</option>
                    <option value="draft">{t('draft')}</option>
                    <option value="out-of-stock">{t('outOfStock')}</option>
                    <option value="inactive">{t('inactive')}</option>
                </select>
            </div>
        </div>
    );
};

export default ProductsActionBar;